import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Add } from "../../Global Icons/ads.svg";
import { editAdBanner, viewAdBanner } from "../../Redux/Actions/banner_adsActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import { useNavigate, useParams } from "react-router-dom";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import SelectInput from "../../Global Functions/selectInput";
import './addAdsBanner.css';

const EditAdsBanners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const dropdownType = ["ad", "banner", "event"];

  const { countryList } = useSelector((state) => state.country);

  const [adsData, setAdsData] = useState({
    id:id,
    title: "",
    type: "",
    start_date: "",
    end_date: "",
    country_id: "",
    is_global: true,
    cover_photo: "",
    file_type: "",
    description: "",
    external_link: "",
  });

  // Fetch country list
  useEffect(() => {
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  // Fetch existing ad/banner data for editing
  useEffect(() => {
    const fetchAdDetails = async () => {
      const res = await dispatch(viewAdBanner(id));
      if (res?.statusCode === 200) {
        const data = res.data;
        setAdsData({
          id:id,
          title: data.title || "",
          type: data.type || "",
          start_date: data.start_date?.split("T")[0] || "",
          end_date: data.end_date?.split("T")[0] || "",
          country_id: data.country || "",
          is_global: data.is_global || true,
          cover_photo: data.cover_photo || "",
          file_type: data.file_type || "",
          description: data.description || "",
          external_link: data.external_link || "",
        });
      } else {
        toast.error("Failed to fetch banner details");
        navigate("/dealsAndOffers");
      }
    };
    fetchAdDetails();
  }, [dispatch, id, navigate]);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setAdsData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const fileType = adsData.cover_photo?.split(".").pop().toLowerCase();
    const imageTypes = ["jpeg", "jpg", "png"];
    const videoTypes = ["mp4", "avi"];

    if (imageTypes.includes(fileType)) {
      adsData.file_type = "image";
    } else if (videoTypes.includes(fileType)) {
      adsData.file_type = "video";
    }
    try {
      const response = await dispatch(editAdBanner(adsData));
      if (response?.statusCode === 200) {
        toast.success("Updated Successfully");
        navigate("/dealsAndOffers");
      } else {
        toast.error(response?.message || "Update failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <MainLayout>
      <div className="addsBanners-container">
        <div className="addsBanners-firstRow">
          <div style={{ display: "flex", alignItems: "center" }}>
            <Add />
            <h1>Edit Ads, Banners</h1>
          </div>
          <button onClick={() => navigate("/dealsAndOffers")} className="button-class">
            View List
          </button>
        </div>

        <div className="add_form">
          <TextInput
            label="Title"
            onChange={handleEditChange}
            name="title"
            required
            type="text"
            placeholder="Enter Title"
            value={adsData.title}
          />
          <SelectInput
            value={adsData.country_id}
            placeholder="Select Country"
            onChange={handleEditChange}
            required
            name="country_id"
            label="Select a Country"
            options={
              Array.isArray(countryList?.data)
                ? countryList.data.map((country) => ({
                    label: country.country_name,
                    value: country._id,
                  }))
                : []
            }
          />
          <SelectInput
            value={adsData.type}
            placeholder="Select Type"
            label="Type"
            name="type"
            required
            onChange={handleEditChange}
            options={dropdownType.map((item) => ({
              label: item.charAt(0).toUpperCase() + item.slice(1),
              value: item,
            }))}
          />
          <TextInput
            type="date"
            label="Start Date"
            name="start_date"
            value={adsData.start_date}
            onChange={handleEditChange}
            required
          />
          <TextInput
            type="date"
            label="End Date"
            name="end_date"
            value={adsData.end_date}
            onChange={handleEditChange}
            required
          />
          <TextInput
            label="Description"
            onChange={handleEditChange}
            value={adsData.description}
            type="text"
            required
            name="description"
          />
          <TextInput
            label="External Link"
            onChange={handleEditChange}
            value={adsData.external_link}
            type="text"
            name="external_link"
          />

          <div>
            <span className="span-class">
              Upload Banner<span style={{ color: "red" }}>*</span>
            </span>
            <input
              accept=".jpg, .jpeg, .png, .mp4, .avi"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const allowed = [
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "video/mp4",
                    "video/x-msvideo",
                  ];
                  if (!allowed.includes(file.type)) {
                    toast.error("Invalid file type!");
                    return;
                  }
                  const url = await AddImage(file);
                  if (url) {
                    setAdsData((prev) => ({ ...prev, cover_photo: url }));
                  }
                }
              }}
              id="image"
              type="file"
              hidden
            />
            <label htmlFor="image" className="label-class-image">
              Click to Upload Image<span style={{ color: "red" }}>*</span>
            </label>

            <ImageShowerModalGlobal
              keyField="cover_photo"
              setState={setAdsData}
              state={adsData}
              file={adsData.cover_photo}
            />
          </div>

          <div className="flex-end span2">
            <button className="button-class" onClick={handleSubmit}>
              Update
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditAdsBanners;
